import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CUSTOMER } from "../config/constants";
import { IAuthState } from "../stateManagement/reducers/authReducer";
import { IRootReducerT } from "../stateManagement/reduxStore";

const LandingPage = () => {

    const { user } = useSelector<IRootReducerT, IAuthState>(state => state.auth);

    const isCustomer = () => {

        if (user && user?.role) {
            if (user.role.name === CUSTOMER) {
                return false;
            }
            return false;
        } else {    //user is anonymous
            return true;        //anonymous is a customer
        }
    }

    const navigate = useNavigate();

    useEffect(() => {
        navigate( isCustomer() ? '/welcome' : '/dashboard', { replace: true });
    }, [user]);

    return null;
}

export default LandingPage;